import { render, staticRenderFns } from "./LoadingView.vue?vue&type=template&id=5c5e53d2&scoped=true&"
import script from "./LoadingView.vue?vue&type=script&lang=js&"
export * from "./LoadingView.vue?vue&type=script&lang=js&"
import style0 from "./LoadingView.vue?vue&type=style&index=0&id=5c5e53d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5e53d2",
  null
  
)

export default component.exports